<template lang="pug">
#analiseSocioambiental
    .row
        .col-12
            mapa(
                v-if='layersMaps',
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :locked='true',
                :height='"230px"',
                :idMapa='"mapaAnaliseSocioAmbiental"'
            )
    .row
        .col-12.collapse-restricao
            collapse-restricao#AREAS_EMBARGADAS_IBAMA(
                :tipoRestricao='tipoRestricoes.AREA_EMBARGADA',
                :showLabelRestricao='true'
            )
                area-embargada-ibama(
                    :areaEmbargada='tipoRestricoes.AREA_EMBARGADA',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#LISTA_AREA_EMBARGADA(
                :tipoRestricao='tipoRestricoes.LISTA_AREA_EMBARGADA',
                :showLabelRestricao='true'
            )
                area-embargada-ibama-lista(
                    :areaEmbargada='tipoRestricoes.LISTA_AREA_EMBARGADA',
                    slot='restricao'
                )

            collapse-restricao#AREA_EMBARGADA_GDF(
                :tipoRestricao='tipoRestricoes.AREA_EMBARGADA_GDF',
                :showLabelRestricao='true'
            )
                area-embargada-gdf(
                    :areaEmbargada='tipoRestricoes.AREA_EMBARGADA_GDF',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#AREA_EMBARGADA_ICMBIO(
                :tipoRestricao='tipoRestricoes.AREA_EMBARGADA_ICMBIO',
                :showLabelRestricao='true'
            )
                area-embargada-icmbio(
                    :areaEmbargada='tipoRestricoes.AREA_EMBARGADA_ICMBIO',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#AREA_EMBARGADA_SEMA_MT(
                :tipoRestricao='tipoRestricoes.AREA_EMBARGADA_SEMA_MT',
                :showLabelRestricao='true'
            )
                area-embargada-sema-mt(
                    :areaEmbargada='tipoRestricoes.AREA_EMBARGADA_SEMA_MT',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#AREA_EMBARGADA_GOIAS(
                :tipoRestricao='tipoRestricoes.AREA_EMBARGADA_GOIAS',
                :showLabelRestricao='true'
            )
                area-embargada-goias(
                    :areaEmbargada='tipoRestricoes.AREA_EMBARGADA_GOIAS',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#LDI(
                :tipoRestricao='tipoRestricoes.LDI',
                :showLabelRestricao='true'
            )
                ldi(
                    :dados='tipoRestricoes.LDI',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#CONTROLE_DESMATAMENTO_AMAZONIA(
                :tipoRestricao='tipoRestricoes.CONTROLE_DESMATAMENTO_AMAZONIA',
                :showLabelRestricao='true'
            )
                controle-desmatamento-amazonia(
                    :dados='tipoRestricoes.CONTROLE_DESMATAMENTO_AMAZONIA',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS(
                :tipoRestricao='tipoRestricoes.CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS',
                :showLabelRestricao='true'
            )
                controle-desmatamento-amazonia-pontos(
                    :dados='tipoRestricoes.CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS',
                    slot='restricao'
                )

            collapse-restricao#TERRAS_INDIGENAS(
                :tipoRestricao='tipoRestricoes.TERRA_INDIGENA',
                :showLabelRestricao='true'
            )
                terras-indigenas(
                    :terrasIndigenas='tipoRestricoes.TERRA_INDIGENA',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#LISTA_SUJA_TRABALHO_ESCRAVO(
                :tipoRestricao='tipoRestricoes.LISTA_SUJA_TRABALHO_ESCRAVO',
                :showLabelRestricao='true',
                mensagemResultadoVazio='Não foram detectadas irregularidades.'
            )
                trabalho-escravo(
                    :trabalhoEscravo='tipoRestricoes.LISTA_SUJA_TRABALHO_ESCRAVO',
                    slot='restricao'
                )

            collapse-restricao#UNIDADES_CONSERVACAO(
                :tipoRestricao='tipoRestricoes.UNIDADE_CONSERVACAO',
                :mensagemResultadoVazio='msgUnidadeConservacao'
            )
                unidades-conservacao(
                    :unidadesConservacao='tipoRestricoes.UNIDADE_CONSERVACAO',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#PRODES(
                :tipoRestricao='tipoRestricoes.PRODES',
                :mensagemResultadoVazio='msgPRODES'
            )
                prodes(
                    :prodes='tipoRestricoes.PRODES',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#AMAZONIA_PROTEGE(
                :tipoRestricao='tipoRestricoes.AMAZONIA_PROTEGE',
                :showLabelRestricao='true'
            )
                amazonia-protege(
                    :amazoniaProtege='tipoRestricoes.AMAZONIA_PROTEGE',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#POVOS_COMUNIDADES_TRADICIONAIS(
                :tipoRestricao='tipoRestricoes.POVOS_COMUNIDADES_TRADICIONAIS',
                :showLabelRestricao='true'
            )
                povos-comunidades-tradicionais(
                    :dados='tipoRestricoes.POVOS_COMUNIDADES_TRADICIONAIS',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#PROTOCOLO_VERDE_GRAOS(
                :tipoRestricao='tipoRestricoes.PROTOCOLO_VERDE_GRAOS',
                :showLabelRestricao='true'
            )
                protocolo-verde-graos(
                    :dados='tipoRestricoes.PROTOCOLO_VERDE_GRAOS',
                    slot='restricao'
                )

            collapse-restricao#FLORESTAS_PUBLICAS(
                :tipoRestricao='tipoRestricoes.FLORESTAS_PUBLICAS',
                :showLabelRestricao='true'
            )
                florestas-publicas(
                    :dados='tipoRestricoes.FLORESTAS_PUBLICAS',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )
</template>

<script>
import CollapseRestricao from '../CollapseRestricao';
import AmazoniaProtege from './restricoes/AmazoniaProtege';
import AreaEmbargadaIbama from './restricoes/AreaEmbargadaIbama';
import AreaEmbargadaIcmbio from './restricoes/AreaEmbargadaIcmbio';
import AreaEmbargadaGdf from './restricoes/AreaEmbargadaGdf';
import AreaEmbargadaSemaMt from './restricoes/AreaEmbargadaSemaMt';
import Ldi from './restricoes/LDI';
import PovosComunidadesTradicionais from './restricoes/PovosComunidadesTradicionais';
import TerrasIndigenas from './restricoes/TerrasIndigenas';
import TrabalhoEscravo from './restricoes/TrabalhoEscravo';
import UnidadesConservacao from './restricoes/UnidadesConservacao';
import Prodes from './restricoes/PRODES';
import AreaEmbargadaIbamaLista from './restricoes/AreaEmbargadaIbamaLista';
import AreaEmbagadaGoias from './restricoes/AreaEmbagadaGoias';
import ProtocoloVerdeGraos from './restricoes/ProtocoloVerdeGraos';
import FlorestasPublicas from './restricoes/FlorestasPublicas';
import ControleDesmatamentoAmazonia from './restricoes/ControleDesmatamentoAmazonia.vue';
import ControleDesmatamentoAmazoniaLista from './restricoes/ControleDesmatamentoAmazoniaLista.vue';

import AreasMonitoradasService from '@/services/AreasMonitoradasService';

import Mapa from '../../components/MapaLeaflet';
import LayerStyle from '../../utils/layerStyles';

export default {
    name: 'AnaliseSocioAmbiental',

    components: {
        Prodes,
        UnidadesConservacao,
        TrabalhoEscravo,
        TerrasIndigenas,
        AreaEmbargadaIbama,
        AreaEmbargadaGdf,
        AreaEmbargadaIcmbio,
        AreaEmbargadaSemaMt,
        Ldi,
        PovosComunidadesTradicionais,
        AmazoniaProtege,
        AreaEmbargadaIbamaLista,
        AreaEmbagadaGoias,
        ProtocoloVerdeGraos,
        CollapseRestricao,
        Mapa,
        FlorestasPublicas,
        ControleDesmatamentoAmazonia,
        ControleDesmatamentoAmazoniaLista
    },

    props: {
        dadosAreaMonitorada: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            imovel: {
                status: {
                    codigo: 'INCONFORMIDADES_ENCONTRADAS'
                }
            },
            msgPRODES: this.$t(
                'mensagens.diagnosticoSocioambiental.naoForamDetectadasSobreposicoesOuAreasMenor25ha'
            ),
            msgUnidadeConservacao: this.$t(
                'mensagens.diagnosticoSocioambiental.naoForamDetectadasSobreposicoesUnidadesConservacao'
            ),
            tipoRestricoes: {
                AREA_EMBARGADA: {
                    nome: this.$t(
                        'mensagens.inteligenciaTerritorial.areasEmbargadasIbama'
                    ),
                    restricoes: [],
                    fonte: {}
                },
                LISTA_AREA_EMBARGADA: {
                    nome: this.$t(
                        'mensagens.camadas.LISTA_AREA_EMBARGADA_IBAMA'
                    ),
                    restricoes: [],
                    fonte: {}
                },
                TERRA_INDIGENA: {
                    nome: this.$t('mensagens.camadas.TERRA_INDIGENA'),
                    restricoes: [],
                    fonte: {}
                },
                LISTA_SUJA_TRABALHO_ESCRAVO: {
                    nome: this.$t(
                        'mensagens.camadas.LISTA_SUJA_TRABALHO_ESCRAVO'
                    ),
                    restricoes: [],
                    fonte: {}
                },
                UNIDADE_CONSERVACAO: {
                    nome: this.$t('mensagens.camadas.UNIDADE_CONSERVACAO'),
                    restricoes: [],
                    fonte: {}
                },
                PRODES: {
                    nome: this.$t('mensagens.camadas.PRODES'),
                    restricoes: [],
                    fonte: {}
                },
                AMAZONIA_PROTEGE: {
                    nome: this.$t('mensagens.camadas.AMAZONIA_PROTEGE'),
                    restricoes: [],
                    fonte: {}
                },
                AREA_EMBARGADA_GDF: {
                    nome: this.$t('mensagens.camadas.AREA_EMBARGADA_GDF'),
                    restricoes: [],
                    fonte: {}
                },
                AREA_EMBARGADA_ICMBIO: {
                    nome: this.$t('mensagens.camadas.AREA_EMBARGADA_ICMBIO'),
                    restricoes: [],
                    fonte: {}
                },
                AREA_EMBARGADA_SEMA_MT: {
                    nome: this.$t('mensagens.camadas.AREA_EMBARGADA_SEMA_MT'),
                    restricoes: [],
                    fonte: {}
                },
                AREA_EMBARGADA_GOIAS: {
                    nome: this.$t('mensagens.camadas.AREA_EMBARGADA_GOIAS'),
                    restricoes: [],
                    fonte: {}
                },
                LDI: {
                    nome: this.$t('mensagens.camadas.LDI'),
                    restricoes: [],
                    fonte: {}
                },
                CONTROLE_DESMATAMENTO_AMAZONIA: {
                    nome: this.$t('mensagens.camadas.CONTROLE_DESMATAMENTO_AMAZONIA'),
                    restricoes: [],
                    fonte: {}
                },
                CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS: {
                    nome: this.$t('mensagens.camadas.CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS'),
                    restricoes: [],
                    fonte: {}
                },
                PROTOCOLO_VERDE_GRAOS: {
                    nome: this.$t('mensagens.camadas.PROTOCOLO_VERDE_GRAOS'),
                    restricoes: [],
                    fonte: {}
                },
                POVOS_COMUNIDADES_TRADICIONAIS: {
                    nome: this.$t(
                        'mensagens.camadas.POVOS_COMUNIDADES_TRADICIONAIS'
                    ),
                    restricoes: [],
                    fonte: {}
                },
                FLORESTAS_PUBLICAS: {
                    nome: this.$t('mensagens.camadas.FLORESTAS_PUBLICAS'),
                    restricoes: [],
                    fonte: {}
                }
            },
            layersMaps: null,

            mapConfig: {
                controls: {
                    zoomControl: true
                }
            }
        };
    },
    mounted() {
        AreasMonitoradasService.analiseSocioambiental(
            this.dadosAreaMonitorada.id
        ).then(results => {
            results.data.forEach(result => {
                let tipoRestricao = this.tipoRestricoes[result.camada.codigo];
                if (tipoRestricao) {
                    tipoRestricao.restricoes = result.resultados;
                    tipoRestricao.fonte = result.camada.fonte;
                }
            });
        });

        this.configureLayersMapa();
    },

    methods: {
        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: this.$t(
                    'mensagens.monitoramento.historico.agricola.areaMonitorada'
                ),
                geoJson: this.dadosAreaMonitorada.geometria
            };

            this.layersMaps.push(layerAreaMonitorada);

            if (
                this.dadosAreaMonitorada.dadosMonitoramento &&
                this.dadosAreaMonitorada.dadosMonitoramento
                    .geometriaAreaPlantada
            ) {
                let layerAreaMonitorada = {
                    style: LayerStyle.AREA_PLANTADA(),
                    name: this.$t(
                        'mensagens.monitoramento.historico.agricola.areaPlantada'
                    ),
                    geoJson:
                        this.dadosAreaMonitorada.dadosMonitoramento
                            .geometriaAreaPlantada,
                    tooltip: `${this.$t(
                        'mensagens.monitoramento.historico.agricola.areaPlantada'
                    )} ${
                        this.dadosAreaMonitorada.dadosMonitoramento
                            .areaPlantadaHa
                    } ha`
                };

                this.layersMaps.push(layerAreaMonitorada);
            }

            this.dadosAreaMonitorada.dadosMonitoramento.dadosCulturasIdentificadas.forEach(
                dadoCultura => {
                    let culturaIdentificada =
                        dadoCultura.culturaIdentificada || {
                            nome: this.$t('mensagens.cultura.NAO_IDENTIFICADA'),
                            codigo: 'NAO_IDENTIFICADA'
                        };
                    const estilo = culturaIdentificada
                        ? LayerStyle[culturaIdentificada.codigo]()
                        : LayerStyle.RESTRICAO();

                    let layerCulturaIdentificada = {
                        style: estilo,
                        name: culturaIdentificada.nome,
                        geoJson: dadoCultura.geometriaCulturaIdentificada,
                        tooltip: `${this.$t(
                            'mensagens.monitoramento.areaPlantadaDe'
                        )} ${culturaIdentificada.nome} - ${
                            dadoCultura.areaCulturaIdentificadaHa
                        } ha`
                    };

                    this.layersMaps.push(layerCulturaIdentificada);
                }
            );
        }
    }
};
</script>

<style lang="scss" scoped>
#analiseSocioambiental {
    .mapa {
        height: 200px;
        background-color: var(--gray);
    }

    .collapse-restricao {
        margin-top: 20px;
    }
}
</style>
